import { render, staticRenderFns } from "./DownloadTopSolid.vue?vue&type=template&id=8aa60650&"
import script from "./DownloadTopSolid.vue?vue&type=script&lang=ts&"
export * from "./DownloadTopSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports